"use client";

import { useSearchParams } from "next/navigation";
import { useOnlineStatus } from "@aera/data-table";
import {
  OFFLINE_MUTATION_MESSAGE,
  canMutateFinancialWork,
} from "@/lib/financialWork";

/** Harness-only override — never used as financial truth. */
const FORCE_OFFLINE_PARAM = "fwOffline";

export function useFinancialWorkMutationGate() {
  const isOnlineNetwork = useOnlineStatus();
  const searchParams = useSearchParams();
  const forceOffline = searchParams?.get(FORCE_OFFLINE_PARAM) === "1";
  const isOnline = isOnlineNetwork && !forceOffline;
  const gate = canMutateFinancialWork(isOnline);
  return {
    isOnline,
    canMutate: gate.allowed,
    blockedReason: gate.reason ?? OFFLINE_MUTATION_MESSAGE,
  };
}
